import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceComponent } from './maintenance.component';
import { MaintenanceService } from './core/services/maintenance.service';
import { SharedModule, HttpLoaderFactory } from '../shared/shared.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaintenanceDisplayMessageComponent } from './maintenance-display-message/maintenance-display-message.component';
import { MaintenanceWindowComponent } from './maintenance-window/maintenance-window.component';
import { FullRestartServiceComponent } from './full-restart-service/full-restart-service.component';
import { EnvironmentStatusComponent } from './environment-status/environment-status.component';
import { LoadingMaintenanceComponent } from './loading-maintenance/loading-maintenance.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MaintenanceCasesComponent } from './maintenance-cases/maintenance-cases.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forChild({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    BsDatepickerModule.forRoot(),
  ],
  declarations: [
    MaintenanceComponent,
    MaintenanceDisplayMessageComponent,
    MaintenanceWindowComponent,
    FullRestartServiceComponent,
    EnvironmentStatusComponent,
    LoadingMaintenanceComponent,
    MaintenanceCasesComponent
  ],
  providers: [
    MaintenanceService
  ],
  exports: [
    MaintenanceComponent,
    MaintenanceDisplayMessageComponent
  ],
  schemas : [CUSTOM_ELEMENTS_SCHEMA]

})
export class MaintenanceModule { }
